import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'ess-tile',
    templateUrl: './tile.html',
    styleUrls: ['./tile.scss']
})
export class SmartTile {

}